import React, {useEffect, useState} from "react";
import Tabs from "react-simply-tabs";
import {getMatchesCompetition} from "../../services/matches";
import {useAuth} from "../../contexts/authContext";
import {getUnconcludedPaidRegistrations, getUnconcludedUnpaidRegistrations} from "../../services/registrations";
import {useSwipeableHook} from "../../utils";
import {useTranslation} from "react-i18next";

// React Components
import Header from "../../components/Header";
import GameCard from "../../components/GameCard";
import NoRegistrationsAlert from "../../components/NoRegistrationsAlert";

// CSS Files
import "./styles.css";

const OtherGames = (props) => {
   const [gameWeeks, setGameWeeks] = useState([]);
   const [unconcludedRegistrations, setUnconcludedRegistrations] = useState([]);
   const {user} = useAuth();
   const { handlers, activeTabIndex, setActiveTabIndex } = useSwipeableHook(Object.keys(gameWeeks).length);
   const { t } = useTranslation();

   useEffect(() => {
      (async () => {
         let gameWeeks = await getMatchesCompetition(
             user.active_enrollment?.league_edition_id,
             user.active_enrollment?.league_id,
             user.active_enrollment?.league_category_id,
             user.active_enrollment?.league_division_id
         )
         let unconcludedPaidRegistrations = await getUnconcludedPaidRegistrations();
         let unconcludedUnpaidRegistrations = await getUnconcludedUnpaidRegistrations();

         setGameWeeks(gameWeeks);
         setUnconcludedRegistrations(unconcludedPaidRegistrations.concat(unconcludedUnpaidRegistrations));
      })()
   }, [user.active_enrollment])

   return <div className={"OtherGames"}>
      <Header class={"mb-0"} headerBarTitle={t("other_matches_page.header")} showHeaderExtras/>
      {(!user.active_enrollment && unconcludedRegistrations.length === 0)
          ? <NoRegistrationsAlert
              text={t("common.no_registrations")}
          />
         : <div className={"flex-grow-1"} {...handlers}>
            <Tabs
               activeTabIndex={activeTabIndex}
               onRequestChange={setActiveTabIndex}
               renderOnlyActiveTab={true}
               wrapperProps={{
                  className: "game-weeks-container"
               }}
               controlsWrapperProps={{
                  className: "tab-controls-container"
               }}
               activeControlProps={{
                  className: "tab-control-active"
               }}
               tabsWrapperProps={{
                  className: "matches-container"
               }}
               controls={Object.keys(gameWeeks).map(gameWeek => <button type="button" className="btn-tab-control">{t("common.game_week")} {gameWeek}</button>)}
            >
               {Object.keys(gameWeeks).map((key) => {
                  return <div key={key}>
                     {gameWeeks[key].map((match, key) => {
                        return <div key={key}>
                           <GameCard key={key} gameInfo={match}/>
                        </div>
                     })}
                  </div>
               })}
            </Tabs>
         </div>
      }
   </div>
}

export default OtherGames;